import { all } from 'redux-saga/effects';
import { onFetchFlights } from '@state/search-results/flights';
import { onFetchEarlyFlights, onApplyEarlyFlights } from '@state/search-results/early-flights';

export function* combinedSearchResultsSagas() {
  yield all([onFetchFlights(), onFetchEarlyFlights(), onApplyEarlyFlights()]);
}
